<script lang="ts">
	import type { IconTitle } from '$lib/domain/icon-title.interface';
	import { icons } from '$lib/config/svg-base';
	import { technologyIcons } from '$lib/config/svg-technologyIcons';

  let iconsBase = {...icons, ...technologyIcons};
	export let reason: IconTitle;
	const itemIcon = reason ? iconsBase[reason.iconName] : null;
</script>

<article>
	<div class="card-icon">
		{@html itemIcon}
	</div>
	
	<h3>{@html reason.title}</h3>
</article>

<style lang="scss">
	@import '$styles/vars';

	article {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 12px;

		.card-icon {
			background-color: $light-grey;
			border-radius: 100%;
			display: flex;
			justify-content: center;
			align-items: center;
			min-width: 140px;
			width: 140px;
			min-height: 140px;
			height: 140px;
			position: relative;

			:global(svg) {
				position: absolute;
			}
		}

		h3 {
			text-align: start;
			font-size: 16px;
			font-weight: 700;
			line-height: 22px;
		}
	}

	@media (max-width: $tablet-size) {
		article {
			.card-icon {
				min-width: 120px;
				width: 120px;
				min-height: 120px;
				height: 120px;
			}
		}
	}

	@media (max-width: $portrait-phone-size) {

		article {
			flex-direction: column;

			.card-icon {
				min-width: 200px;
				width: 200px;
				min-height: 200px;
				height: 200px;

				:global(svg) {
					width: 80px;
					height: 80px;
				}

			}
		}
	}
</style>
